import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';
import { DirDetailsService } from 'src/app/modules/directory/services/dir-details.service';
import { FeedService } from 'src/app/modules/feeds/services/feed.service';
import { Router } from '@angular/router';
import { SlsService } from 'src/app/core/services/sls.service';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-follow-listing',
  templateUrl: './follow-listing.component.html',
  styleUrls: ['./follow-listing.component.scss']
})
export class FollowListingComponent implements OnInit {
  @Input() following: any;
  @Input() followers: any;
  @Input() identifyName: any;

  isFollowTriggered: boolean = false;
  private followSubscription: Subscription;
  countOfFollowing: any;
  countOfFollowers: any;
  loginDetails: any;
  followinguser: any;
  followeruser: any;
  getInitials(name: string): string {
    if (!name) return '';
    const words = name.split(' ');
    let initials = words[0].charAt(0);
    if (words.length > 1) {
      initials += words[words.length - 1].charAt(0);
    }
    return initials.toUpperCase();
  }


  constructor(private dirService: DirDetailsService, private loginService: LoginService, private feedService: FeedService, private router: Router, private sls: SlsService) { }
  ngOnInit(): void {

    this.loginDetails = this.loginService.getLoginData();
    this.fetchUserCounts();
  }
  fetchUserCounts(): void {
    const response = this.dirService.getUsersCount(this.loginDetails.id).subscribe((data: any) => {
      this.countOfFollowing = data.to_whome_i_am_following.length
      this.countOfFollowers = data.who_is_following.length
      this.followinguser = data.to_whome_i_am_following
      this.followeruser = data.who_is_following
    });
  }
  get FollowFollowingList(): any[] {

    return this.identifyName === 'Following' ? this.following : this.followers || [];
  }


  isMutual(user: any): boolean {
    const followingList = this.followeruser || [];
    const followersList = this.followinguser || [];

    const followerIds: string[] = [];





    for (const user of followersList) {
      if (user.follower_dental_supplier_id) {
        followerIds.push(user.follower_dental_supplier_id);
      }
      if (user.follower_dental_practice_id) {
        followerIds.push(user.follower_dental_practice_id);
      }
      if (user.follower_dental_professional_id) {
        followerIds.push(user.follower_dental_professional_id);
      }

    }

    return followerIds.includes(user.id);

  }





  handleFollowTrigger() {
    if (this.isFollowTriggered) {
      alert('Follow List Activated!');
    }
  }
  unfollow(user: any): void {

    this.dirService.deleteFollowStatus(user.id).then((res: any) => {
      if (res) {
        this.following = this.following.filter((u: any) => u.id !== user.id);
        this.feedService.updateApprovalStatus(true);

      }
    });
  }
  goToDetails(user: any): void {

    const follower = user.original;
    const followingId = user.followingid;

    if (!followingId) {
      console.warn('No following ID found.');
      return;
    }

    // Find and log full details of the object that matches the followingId
    let fullDetails = null;

    if (follower?.follower_dental_supplier_id === followingId) {
      fullDetails = follower.follower_dental_supplier;
    } else if (follower?.follower_dental_professional_id === followingId) {
      fullDetails = follower.follower_dental_professional;
    } else if (follower?.follower_dental_practice_id === followingId) {
      fullDetails = follower.follower_dental_practice;
    }




    // Navigate to details page with followingId
    this.router.navigate(['/directory/directory-details', followingId], { state: { user } });
  }

  ngOnDestroy() {
    if (this.followSubscription) {
      this.followSubscription.unsubscribe();
    }
  }

  followBack(business: any) {

    event.stopPropagation();
    const loginData = this.sls.get('loginData');
    if (!loginData || !loginData.id) {
      console.error("User not logged in");
      return;
    }
    const targetUserType = business.type;
    const followStatus = targetUserType === "SUPPLIER" ? 'APPROVED' : 'PENDING';
    const formData = {
      id: uuidv4(),
      // followed_by_user_id: loginData.id,
      // following_user_id: business.id,
      ...(loginData.type === "SUPPLIER" ? { dental_supplier_id: loginData.id } : {}),
      ...(loginData.type === "PROFESSIONAL" ? { dental_professional_id: loginData.id } : {}),
      ...(loginData.type === "PRACTICE" ? { dental_practice_id: loginData.id } : {}),
      ...(loginData.type === "ADMIN" ? { dental_admin_id: loginData.id } : {}),
      ...(business.type === "SUPPLIER" ? { follower_dental_supplier_id: business.id } : {}),
      ...(business.type === "PROFESSIONAL" ? { follower_dental_professional_id: business.id } : {}),
      ...(business.type === "PRACTICE" ? { follower_dental_practice_id: business.id } : {}),
      // ...(business.type === "ADMIN" ? { dental_admin_id: loginData.id } : {}),
      following_status: followStatus
    };




    this.dirService.addFollowerData(formData).then(response => {
      if (response) {
        this.followinguser.push({
          ...formData,
          follower_dental_supplier_id: formData.follower_dental_supplier_id,
          follower_dental_practice_id: formData.follower_dental_practice_id,
          follower_dental_professional_id: formData.follower_dental_professional_id,
          // follower_dental_admin_id: formData.follower_dental_admin_id
        });

        // Optionally show a toast/snackbar

        // Optional: notify other components
        this.feedService.updateApprovalStatus(true);
      }
    }).catch(error => {
      console.error("Error following business:", error);
    });
  }



}